import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { partitionBy } from "@examspark/common";
import { useAppContext } from "@examspark/common-app";
import { Text, Button } from "@examspark/common-ui";
import { IconRedirectLine } from "@examspark/common-ui/dist/components/icons";
import { UserClassroom } from "@examspark/types";

import ClassroomsGrid from "../classroom/ClassroomsGrid";
import ClassroomsSetupPrompt from "../classroom/ClassroomsSetupPrompt";

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const DashboardSections = (props: {
  sections?: UserClassroom[];
  onCreate?: () => void;
}) => {
  const [state] = useAppContext();
  const navigate = useNavigate();

  const { myClassrooms } = partitionBy(props.sections ?? [], (s) =>
    s.user?.id === state.user?.id ? "myClassrooms" : "otherClassrooms",
  );

  if (props.sections == null) return null;

  return (
    <>
      <PageLayout>
        <Text.H1>
          My Classrooms
          <Button
            title="All Classrooms"
            variant="plain"
            onClick={() => navigate("/classrooms")}
          >
            View All <IconRedirectLine width="16" />
          </Button>
        </Text.H1>
        {!myClassrooms?.length && (
          <ClassroomsSetupPrompt onCreate={props.onCreate} />
        )}
        {!!myClassrooms?.length && (
          <ClassroomsGrid
            sections={myClassrooms}
            allowCreateSection
            onCreate={props.onCreate}
          />
        )}
      </PageLayout>
    </>
  );
};

export default DashboardSections;
